<app-context-menu
  [options]="{ width: '240px', noSpacing: true }"
  *ngIf="
    allowedAndEnabledFeedbackOptions.includes('favourite') ||
    allowedAndEnabledFeedbackOptions.includes('flag') ||
    allowedAndEnabledFeedbackOptions.includes('color_label')
  "
>
  <button
    appButton
    name="filter"
    location="view-filter"
    color="default-opacity"
    shape="round"
    height="1"
    size="1"
    [hasIcon]="true"
    weight="bold"
    contextButton
  >
    <app-svg src="/assets/icons/filter.svg"></app-svg>
    <span>{{ 'filter-assets' | translate }}</span>
    <span class="changes-dot" *ngIf="hasFilters"></span>
  </button>

  <div class="button-menu" contextContent>
    <ng-container *ngIf="allowedAndEnabledFeedbackOptions.includes('favourite')">
      <app-radio-button
        [checked]="allFilters.is_liked === true"
        (click)="toggleFilter('is_liked', true)"
        [hasIcon]="true"
        location="view-filter"
      >
        <app-svg src="/assets/icons/heart-filled.svg" color="warn"></app-svg>
        <span class="standard-dark-text">{{ 'your-favorites' | translate }}</span>
      </app-radio-button>
      <app-radio-button
        [checked]="allFilters.is_liked === false"
        (click)="toggleFilter('is_liked', false)"
        [hasIcon]="true"
        location="view-filter"
      >
        <app-svg src="/assets/icons/heart-empty.svg" color="grey-50"></app-svg>
        <span class="standard-dark-text">{{ 'not-favorited' | translate }}</span>
      </app-radio-button>
    </ng-container>

    <ng-container *ngIf="allowedAndEnabledFeedbackOptions.includes('flag')">
      <div class="divider" *ngIf="allowedAndEnabledFeedbackOptions.includes('favourite')"></div>

      <app-radio-button
        [checked]="allFilters.status === 'approved'"
        (click)="toggleFilter('status', 'approved')"
        [hasIcon]="true"
        location="view-filter"
      >
        <app-svg src="/assets/icons/flag-check.svg" color="green"></app-svg>
        <span class="standard-dark-text">{{ 'approved' | translate }}</span>
      </app-radio-button>

      <app-radio-button
        [checked]="allFilters.status === 'rejected'"
        (click)="toggleFilter('status', 'rejected')"
        [hasIcon]="true"
        location="view-filter"
      >
        <app-svg src="/assets/icons/flag-cross-outline.svg" color="warn"></app-svg>
        <span class="standard-dark-text">{{ 'rejected' | translate }}</span>
      </app-radio-button>
    </ng-container>

    <ng-container *ngIf="allowedAndEnabledFeedbackOptions.includes('color_label')">
      <div
        class="divider"
        *ngIf="
          allowedAndEnabledFeedbackOptions.includes('favourite') || allowedAndEnabledFeedbackOptions.includes('flag')
        "
      ></div>

      <app-radio-button
        *ngFor="let label of colorLabels"
        [checked]="allFilters.color_label[label.color]"
        (click)="toggleFilter('color_label', label.color)"
        [hasIcon]="true"
        location="view-filter"
      >
        <app-svg src="/assets/icons/tag-filled.svg" [attr.color]="label.color"></app-svg>
        <span class="standard-dark-text">{{ label.name }}</span>
      </app-radio-button>
    </ng-container>
  </div>
</app-context-menu>
